// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 44 44"
    {...props}
  >
    <path
      fill="#fff"
      d="M3.32959 15.6667H28.6629C31.4632 15.6667 32.8633 15.6667 33.9329 16.2116C34.8737 16.691 35.6386 17.4559 36.118 18.3967C36.6629 19.4663 36.6629 20.8664 36.6629 23.6667V31C36.6629 33.8003 36.6629 35.2004 36.118 36.27C35.6386 37.2108 34.8737 37.9757 33.9329 38.455C32.8633 39 31.4632 39 28.6629 39H11.3296C8.52933 39 7.1292 39 6.05964 38.455C5.11883 37.9757 4.35392 37.2108 3.87456 36.27C3.32959 35.2004 3.32959 33.8003 3.32959 31V15.6667Z"
    />
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M21.6629 15.6667L19.8037 11.9482C19.2686 10.878 19.001 10.3429 18.6019 9.95194C18.2489 9.60622 17.8235 9.34329 17.3564 9.18218C16.8282 9 16.2299 9 15.0334 9H8.66292C6.79608 9 5.86266 9 5.14962 9.36331C4.52241 9.68289 4.01248 10.1928 3.6929 10.82C3.32959 11.5331 3.32959 12.4665 3.32959 14.3333V15.6667M3.32959 15.6667H28.6629C31.4632 15.6667 32.8633 15.6667 33.9329 16.2116C34.8737 16.691 35.6386 17.4559 36.118 18.3967C36.6629 19.4663 36.6629 20.8664 36.6629 23.6667V31C36.6629 33.8003 36.6629 35.2004 36.118 36.27C35.6386 37.2108 34.8737 37.9757 33.9329 38.455C32.8633 39 31.4632 39 28.6629 39H11.3296C8.52933 39 7.1292 39 6.05964 38.455C5.11883 37.9757 4.35392 37.2108 3.87456 36.27C3.32959 35.2004 3.32959 33.8003 3.32959 31V15.6667Z"
    />
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M21.6636 23.9985 23.5394 30.668H24.7915L26.6657 23.9985M17.1328 23.9985H14.9935C14.0727 23.9985 13.3262 24.745 13.3262 25.6659V29.0006C13.3262 29.9215 14.0727 30.668 14.9935 30.668H17.1328"
    />
    <circle
      cx={33.004}
      cy={11}
      r={10}
      fill="#6421B9"
      stroke="#fff"
      strokeWidth={2}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M33.0017 7.14062V10.9978V14.8549M29.1445 10.9978H36.8588"
    />
  </svg>
);
const IconCvAdd = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconCvAdd;
